export const validateCredits = async (actionCode, metadata) => {
  const res = await fetch('/api/system/credits/validate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ actionCode, metadata })
  })
  return res.ok
}
